module.exports = __webpack_public_path__ + "img/water.afd37f63.png";